(ns com.theplantscape.plant-web.api.core
  (:require [com.theplantscape.plant-web.draw.api :as api]
            [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]
            [clojure.core.async :refer [go chan <! >! put!]]))


(defn api-errors [response]
  (case (:status response)
    200 nil
    400 {:msg "Invalid data sent!"}
    0 {:msg "Could not contact service, offline or fatal error occurred."}
    {:msg "Could not contact service, offline or fatal error occurred."}))

(defn db-connected [cb cb-error]
  (api/make-request
   {:method :get
    :error-handler cb-error
    :uri (api-url-build "/status/")}
   cb))

(defn sync-chan
  [response-chan request-fn args]
  (apply request-fn [args #(put! response-chan %)]))

(defn sync
  [request-fn args]
  (let [response-chan (chan)]
    (prn [args #(put! response-chan %)])
    (apply request-fn [args #(put! response-chan %)])
    response-chan))


(comment
  (db-connected #(prn "200")  #(prn (str "error " (:status %))))
)
